import React from 'react';

import { ObjectSidebarControl } from '@confluence/object-sidebar-components/entry-points/ObjectSidebarControl.tsx';

interface ObjectSidebarControlSmartCreateDatabaseEditorProps {
	undoRedoButtonActions?: {
		canUndo?: boolean;
		canRedo?: boolean;
		undo?: () => boolean;
		redo?: () => boolean;
	};
	contentId: string;
	spaceKey: string;
	contentType: string;
	contentTitle: string | null;
}

export function ObjectSidebarControlSmartCreateDatabaseEditor({
	undoRedoButtonActions,
	contentId,
	spaceKey,
	contentType,
	contentTitle,
}: ObjectSidebarControlSmartCreateDatabaseEditorProps): React.JSX.Element {
	return (
		<ObjectSidebarControl
			key="object-sidebar-control"
			hasCommentsButton={false}
			hasDetailsButton={false}
			hasLoomButton={false}
			hasUndoRedoButton={!!undoRedoButtonActions}
			undoRedoButtonActions={undoRedoButtonActions}
			hasAiButton={false}
			hasAudioButton={false}
			hasFeedbackButton={false}
			contentId={contentId}
			spaceKey={spaceKey}
			contentType={contentType}
			contentTitle={contentTitle}
			largeBottomPadding
			isDatabasesStagingArea
		/>
	);
}
